import { classNames } from "primereact/utils";

import { usePageHeaderContext } from "../page-header.context";
import styles from "../page-header.module.scss";
import type { PageHeaderTitleProps } from "../types-page-header";

export function PageHeaderTitle({
  children,
  visuallyHidden = false,
  className,
  ...rest
}: PageHeaderTitleProps) {
  const { classNames: parts, partTestId } = usePageHeaderContext();

  return (
    <h1
      className={classNames(styles.title, parts.title, className)}
      data-visually-hidden={visuallyHidden || undefined}
      data-testid={partTestId("titulo")}
      {...rest}
    >
      {children}
    </h1>
  );
}
PageHeaderTitle.displayName = "PageHeader.Title";
